import type { ICatalog, ILocalizedText } from '@platform/core/types';

/**
 * Назва типу запису як «модуля» прототипу v4 (крихти конструктора модулів, bm.name): головний тип — назва модуля в просторі, дочірній —
 * назва типу з каталогу простору; невідомий тип — null. Чиста функція.
 */
export function recordTypeTitle(catalog: ICatalog | undefined, rtKey: string | undefined, label: (text: ILocalizedText | null | undefined) => string): string | null {
  if (!rtKey) return null;
  for (const m of catalog?.modules ?? []) {
    const rt = m.recordTypes.find((r) => r.key === rtKey);
    if (rt) return (rt.main ? label(m.name) : label(rt.name)) || rtKey;
  }
  return null;
}
